module.exports = __webpack_public_path__ + "static/media/spinner.d0371a70.gif";